module.exports = __webpack_public_path__ + "img/no-image.407cb06a.png";